import React, { useEffect } from "react";
import "./ScrollImg.css";

import nc1 from "../../Assets/project14/nc1.webp";
import nc2 from "../../Assets/project14/nc2.webp";
import nc3 from "../../Assets/project14/nc3.webp";
import nc4 from "../../Assets/project14/nc4.webp";
import nc5 from "../../Assets/project14/nc5.webp";
import nc6 from "../../Assets/project14/nc6.webp";
import nc7 from "../../Assets/project14/nc7.webp";
import nc8 from "../../Assets/project14/nc8.webp";
import nc9 from "../../Assets/project14/nc9.webp";
import nc10 from "../../Assets/project14/nc10.webp";
import nc11 from "../../Assets/project14/nc11.webp";


const ScrollImg14 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [nc1, nc2, nc3, nc4, nc5, nc6, nc7, nc8, nc9, nc10, nc11];


  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg14;
